<template>
  <section
    id="cover"
    class="te-bg-unity-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 500px"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faUnity"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      Unityコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      オリジナルのゲームアプリを開発して公開しよう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        Unityを学習・勉強して短期間でオリジナルのゲー
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >ムアプリを開発できるようになる講座。スクールでは、Unityであなたのオリジナルゲームアプリを公開することがゴールです。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでオリジナルゲームアプリの開発までサポート。転職サポートもあり。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUnity } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Props {
  beginsAt: Date
  closesAt: Date
}

const options = {
  async setup() {
    return {
      faUnity,
      faChevronUp,
      faChevronDown,
    }
  },
  props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-unity-image {
  background-image: linear-gradient(
    to top,
    rgba(41, 41, 41, .75),
    rgba(92, 92, 92, .75)
  ),
    url('~/assets/images/Te/TeCourse/Unity/Cover/block-unity.jpg');
}

</style>
